import { apiSlice } from "../../../api/apiSlice";
import { GET_ASSIGNED_COURSES, GET_ASSIGNED_PAST_COURSES } from "../../../constants";

export const courseAssignmentSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        getCourseAssignment: builder.query({
            query: (data: any) => ({
                url: GET_ASSIGNED_COURSES,
                method: 'GET',
                params: data,
            }),
            providesTags: ['CourseAssignment'],
        }),
        getCoursePastAssignment: builder.query({
            query: (data: any) => ({
                url: GET_ASSIGNED_PAST_COURSES,
                method: 'GET',
                params: data,
            }),
            providesTags: ['CourseAssignment'],
        }),
    }),
});

export const { useGetCourseAssignmentQuery, useGetCoursePastAssignmentQuery } = courseAssignmentSlice;